<script setup>
import { onMounted, ref } from 'vue'
import { PageHeading, Icon } from '@components'

import { useSettings } from '@store/settings'
const $settings = useSettings()

onMounted(async () => {
    await $settings.fetchSettings()
})

// Quick actions menu
const quickActions = ref([
    { title: 'General', route: { name: 'settings.general' } },
    { title: `Business Profile`, route: { name: 'settings.business' }, visibility: $settings.addons.staffs },
    { title: `${$settings.labels.service?.singular} Provider`, route: { name: 'settings.provider' }, visibility: !$settings.addons.staffs },
    { title: 'Business Hours', route: { name: 'settings.business_hours' } },
    { title: `${$settings.labels.payment?.plural}`, route: { name: 'settings.payments' } },
    { title: 'Labels', route: { name: 'settings.labels' } },
    { title: 'Addons', route: { name: 'settings.addons' } },
])

// settings menu
const settingsMenu = ref([
    { title: 'General', icon: 'settings01', route: { name: 'settings.general' }, details: `Use these settings to define plugin general settings and default settings for your ${String($settings.labels.service?.plural).toLowerCase()} and ${String($settings.labels.appointment?.plural).toLowerCase()}` },
    { title: `Business Profile`, icon: 'building02', route: { name: 'settings.business' }, details: 'Use these settings to set up picture, name, address, phone and website of your company', visibility: $settings.addons.staffs },
    { title: `${$settings.labels.service?.singular} Provider Profile`, icon: 'building02', route: { name: 'settings.provider' }, details: 'Use these settings to set up picture, name, address, phone and website of your company', visibility: !$settings.addons.staffs },
    { title: `${$settings.addons.staffs ? 'Business' : 'Working'} Hours`, icon: 'clock', route: { name: 'settings.business_hours' }, details: `Use these settings to set company working hours and days off which will be applied for every ${String($settings.labels.staff?.singular).toLowerCase()}` },
    { title: `${$settings.labels.payment?.plural}`, icon: 'currencyDollarCircle', route: { name: 'settings.payments' }, details: `Use these settings to set price format, ${String($settings.labels.payment?.singular).toLowerCase()} method and coupons that will be used in all bookings` },
    { title: 'Labels', icon: 'edit05', route: { name: 'settings.labels' }, details: 'Use these settings to set up labels and customize the terminology across the system to suit your preferences' },
    { title: 'Addons', icon: 'cube01', route: { name: 'settings.addons' }, details: 'Customize PreBook by enabling or disabling extra features to fit your business requirements' },
    // { title: 'Integrations', icon: 'link02', route: { name: 'settings.integrations' }, details: 'Manage Google Calendar Integration, Outlook Calendar Integration, Zoom Integration and Web Hooks' },
])

</script>

<template>
    <div class="md:max-w-[992px] m-auto mt-[-28px]">
        <!-- page title -->
        <PageHeading title="Settings" :divider="false" class="pb-2" />

        <!-- Quick actions -->
        <div>
            <div class="text-[#475467] text-sm font-normal mb-4">Quick actions</div>

            <div class="flex items-center gap-4 overflow-auto mb-7 md:overflow-visible md:flex-wrap">
                <template v-for="(menu, index) in quickActions" :key="index">
                    <router-link v-if="menu.visibility == undefined || menu.visibility" :to="{ name: menu.route.name }" class="capitalize text-nowrap border border-[#EAECF0] rounded-[30px] text-[#475467] text-[12px] font-medium py-[7px] px-3 hover:bg-[#f8f9f9] transition-all">
                        {{ menu.title }}
                    </router-link>
                </template>
            </div>
        </div>

        <!-- Settings -->
        <div class="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
            <template v-for="(menu, index) in settingsMenu" :key="index">
                <router-link v-if="menu.visibility == undefined || menu.visibility" :to="{ name: menu.route.name }" class="border border-[#EAECF0] rounded-lg p-6 hover:bg-[#f8f9f9] transition-all">
                    <Icon :name="menu.icon" size="32px" class="text-[#101828] mb-3" />
                    <div class="text-[#101828] text-[20px] font-semibold mb-2 capitalize">{{ menu.title }}</div>
                    <div class="text-[#475467] text-sm font-normal">{{ menu.details }}</div>
                </router-link>
            </template>
        </div>

    </div>
</template>
